import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import {
    DatePicker,
    Button,
    Select,
    Divider,
    Form,
    Input,
    InputNumber,
    Col,
    Row,
    Popover,
    Checkbox
} from 'antd';
import {
    QuestionCircleOutlined
} from '@ant-design/icons';
import "./Common.css";
import "./PropertyAndLoan.css";
import * as com from "../../Common"
import { connect } from 'react-redux'
import * as act from "../../Store/actions"
import GoogleAutocomplete from '../../Common/GoogleAutocomplete/GoogleAutocomplete'
import {
    validateMessages,
} from './constants'

const mapStateToProps = (state) => {
    return {
        property: state.application.property,
        application: state.application,
        progress: state.progress,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateHardMoneyLoanAttribute: (t, verb) => {
        dispatch(act.UpdateHardMoneyLoanAttribute(t, verb));
    },
    changeMainPropertyAttribute: (t, verb) => {
        dispatch(act.ChangeMainPropertyAttribute(t, verb));
    },
    changeMainPropertyPurpose: (val) => {
        dispatch(act.ChangeMainPropertyPurpose(val));
    },
    updateHasCoborrower: (val) => {
        dispatch(act.UpdateHasCoborrower(val))
    },
    updateProduct: (v, verb) => {
        dispatch(act.UpdateProduct(v, verb))
    },
    changeBorrowerInfo: (v, verb) => {
        dispatch(act.ChangeBorrowerInfo(v, "borrower", verb))
    },
    changeCoBorrowerInfo: (v, verb) => {
        dispatch(act.ChangeBorrowerInfo(v, "coborrower", verb))
    },
});

export default function ThirdPartyService(props) {
    const interviewfinished = com.CurrentStatus[props.application.currentStatus] >= 200
    let disabledOnclick = interviewfinished ? props.onSubmittedDisableClick : null
    const [form] = Form.useForm();

    const onFinish = (values) => {
        props.finish(values)
    }

    const formInitial = {
        titlecompany: props.application.hardmoneyloan.titlecontact.company,
        titlename: props.application.hardmoneyloan.titlecontact.name,
        titlephone: props.application.hardmoneyloan.titlecontact.phone,
        titleemail: props.application.hardmoneyloan.titlecontact.email,
        escrowcompany: props.application.hardmoneyloan.escrowcontact.company,
        escrowname: props.application.hardmoneyloan.escrowcontact.name,
        escrowphone: props.application.hardmoneyloan.escrowcontact.phone,
        escrowemail: props.application.hardmoneyloan.escrowcontact.email,
        insurancecompany: props.application.hardmoneyloan.insurancecontact.company,
        insurancename: props.application.hardmoneyloan.insurancecontact.name,
        insurancephone: props.application.hardmoneyloan.insurancecontact.phone,
        insuranceemail: props.application.hardmoneyloan.insurancecontact.email,
        appraisalschedulecompany: props.application.hardmoneyloan.appraisalschedulecontact.company,
        appraisalschedulename: props.application.hardmoneyloan.appraisalschedulecontact.name,
        appraisalschedulephone: props.application.hardmoneyloan.appraisalschedulecontact.phone,
        appraisalscheduleemail: props.application.hardmoneyloan.appraisalschedulecontact.email,
        appraisalpaymentcompany: props.application.hardmoneyloan.appraisalpaymentcontact.company,
        appraisalpaymentname: props.application.hardmoneyloan.appraisalpaymentcontact.name,
        appraisalpaymentphone: props.application.hardmoneyloan.appraisalpaymentcontact.phone,
        appraisalpaymentemail: props.application.hardmoneyloan.appraisalpaymentcontact.email,
    }

    const renderActionButtons = () => <Row gutter={10}>
        <Col>
            <Form.Item>
                <Button
                    disabled={false}
                    type="default"
                    className='secondary-btn'
                    onClick={props.back}
                >
                    Back
                </Button>
            </Form.Item>
        </Col>
        <Col>
            <Form.Item>
                <Button
                    type="primary"
                    className='common-btn'
                    htmlType="submit"
                    disabled={false}
                    onClick={() => {
                        // Scroll to top after click continue
                        window.document.body.scrollIntoView({ behavior: "smooth", inline: "nearest" });
                    }}
                >
                    Continue
                </Button>
            </Form.Item>
        </Col>
    </Row>

    const onFieldsChanged = (changedValues, allValues) => {
        // console.log(changedValues, allValues)
        const hasError = form.getFieldsError().some(x => x.errors.length > 0)
        if (hasError) props.resetProgress()
    }

    const onChangeThirdParty = (e, field, type) => {
        let info = props.application.hardmoneyloan[type+'contact']
        info[field.replace(type, '')] = e
        props.updateHardMoneyLoanAttribute(info, type+'contact')
    }

    return (
        <div className="borrower-form text-left">
            <Form
                className='application-form'
                layout='vertical'
                form={form}
                disabled={interviewfinished}
                onFieldsChange={onFieldsChanged}
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center',
                    block: 'center',
                }}
                onFinish={onFinish}
                initialValues={formInitial}
                validateMessages={validateMessages}
                size="large"
            >
                <Row>
                    <span className='form-title'>Third Party Contacts Information</span>
                </Row>  
                <Divider />
                <Row>
                    <span className='form-sub-title'>Title Service Contact</span>
                </Row>                                        
                <Row gutter={30}>
                    <Col span={12}>
                        <Form.Item
                            name="titlecompany"
                            label="Company"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "titlecompany", "title")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="titlename"
                            label="Contact name"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "titlename", "title")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="titlephone"
                            label="Phone"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "titlephone", "title")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="titleemail"
                            label="Email"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "titleemail", "title")} />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <span className='form-sub-title'>Escrow Service Contact</span>
                </Row>  
                <Row gutter={30}>
                    <Col span={12}>
                        <Form.Item
                            name="escrowcompany"
                            label="Company"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "escrowcompany", "escrow")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="escrowname"
                            label="Contact name"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "escrowname", "escrow")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="escrowphone"
                            label="Phone"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "escrowphone", "escrow")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="escrowemail"
                            label="Email"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "escrowemail", "escrow")} />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <span className='form-sub-title'>Insurance Service Contact</span>
                </Row>  
                <Row gutter={30}>
                    <Col span={12}>
                        <Form.Item
                            name="insurancecompany"
                            label="Company"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "insurancecompany", "insurance")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="insurancename"
                            label="Contact name"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "insurancename", "insurance")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="insurancephone"
                            label="Phone"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "insurancephone", "insurance")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="insuranceemail"
                            label="Email"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "insuranceemail", "insurance")} />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <span className='form-sub-title'>Appraisal Schedule Contact</span>
                </Row> 
                <Row gutter={30}>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalschedulecompany"
                            label="Company"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalschedulecompany", "appraisalschedule")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalschedulename"
                            label="Contact name"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalschedulename", "appraisalschedule")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalschedulephone"
                            label="Phone"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalschedulephone", "appraisalschedule")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalscheduleemail"
                            label="Email"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalscheduleemail", "appraisalschedule")} />
                        </Form.Item>
                    </Col>
                </Row> 
                <Divider />
                <Row>
                    <span className='form-sub-title'>Appraisal Payment Contact</span>
                </Row>
                <Row gutter={30}>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalpaymentcompany"
                            label="Company"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalpaymentcompany", "appraisalpayment")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalpaymentname"
                            label="Contact name"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalpaymentname", "appraisalpayment")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalpaymentphone"
                            label="Phone"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalpaymentphone", "appraisalpayment")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="appraisalpaymentemail"
                            label="Email"
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            onClick={disabledOnclick}
                        >
                            <Input placeholder="N/A" onChange={e => onChangeThirdParty(e.target.value, "appraisalpaymentemail", "appraisalpayment")} />
                        </Form.Item>
                    </Col>
                </Row>
                {renderActionButtons()}
            </Form>
        </div>
    )
}

ThirdPartyService = connect(mapStateToProps, mapDispatchToProps)(ThirdPartyService);
